import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { NavigationPage } from '../../../../Redux/Reducers/NavigationReducer';
import { useAppSelector } from '../../../../Redux/Store/hooks';
import { CatalogFileCollection } from '../../../../common/libraries/fileFormats/catalog/catalog';

import imgNoImage from '../../../../Resources/Images/no-banner-image.png';

type SliderComponentParameters = {
  spotlight : CatalogFileCollection[],
  displayNewPage : (collectionName: string, objectName: string, pageType: string) => void
};

export function SliderComponent({ spotlight, displayNewPage } : SliderComponentParameters) {

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  // From the store, get the environment settings
  const environmentSettings = useAppSelector((state) => {
    return state.EnvironmentSettingsReducer;
  });

  const getCoverPicturePath = (collection : CatalogFileCollection) : string => {

    if (collection.coverPictureIndex >= 0) {
      return (
        environmentSettings.catalogInfoPath
        + collection.imageRef[collection.coverPictureIndex]
      );
    }
    return imgNoImage;
  };

  const carouselItem = (collection : CatalogFileCollection, id : number) => {
    return (
      <Carousel.Item key={id}>
        <div key={id} style={{ height: '250px' }}>
          <img
            className="d-block"
            src={getCoverPicturePath(collection)}
            alt="Second slide"
            style={{
              height: '100%',
              width: '100%',
              margin: 'auto',
              objectFit: 'contain',
            }}
          />
          <button
            type="button"
            className="btn btn-dark carousel-item-btn"
            onClick={() => {
              displayNewPage(
                collection.name,
                '',
                NavigationPage.Collection,
              );
            }}
          >
            {strings.INFORMATION_SLIDER_BUTTON}
          </button>
        </div>
      </Carousel.Item>
    );
  };

  return <Carousel>{spotlight.map((c, id) => carouselItem(c, id))}</Carousel>;
}
